import { CornerDownRight } from "lucide-react";
import type { FC } from "react";

import { MetaLine } from "@/components/ui/meta-line";

import { useCitation } from "../hooks/useResearch";
import { courtLabel } from "../sources";
import { WeightBadge } from "./WeightBadge";

type Props = {
  query: string;
  onOpen: (id: string) => void;
};

/** A query that is a citation goes straight to its document. */
export const CitationMatch: FC<Props> = ({ query, onOpen }) => {
  const lookup = useCitation(query);
  const doc = lookup.data?.resolved ? lookup.data.document : null;
  if (!doc?.id) return null;
  const { id } = doc;
  return (
    <button
      type="button"
      onClick={() => onOpen(id)}
      className="mx-4 mt-3 flex items-start gap-3 rounded-xl bg-accent-soft px-3 py-2.5 text-left transition-colors duration-100 hover:bg-accent-soft/70"
      data-testid="research-citation-match"
    >
      <CornerDownRight className="mt-0.5 size-3.5 shrink-0 text-accent-seed" />
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-sm text-accent-seed">
          Go to {lookup.data?.display || doc.citation || query}
        </span>
        <span className="truncate text-base font-medium text-fg">
          {doc.title}
        </span>
        <span className="flex items-center gap-1.5">
          <WeightBadge weight={doc.weight} />
          <MetaLine parts={[courtLabel(doc), doc.date]} />
        </span>
      </span>
    </button>
  );
};
